import { ReactNode } from "react";
import { LogoWithNameIcon } from "../../components";
import "./LoginContainer.scss";

type LoginContainerProps = {
  children: ReactNode;
};

export const LoginContainer = ({ children }: LoginContainerProps) => {
  return (
    <div className="wrapper">
      {/* <div className="background-node" /> */}
      <div className="container">
        <LogoWithNameIcon className="logo" />
        {children}
      </div>
    </div>
  );
};
